module.exports = __webpack_public_path__ + "static/img/yongjin.840ce993.png";